import { jsxs as c, jsx as o, Fragment as m } from "react/jsx-runtime";
import _, { useId as y } from "react";
import { c as j } from "./clsx-OuTLNxxd.js";
import { c as x } from "./createLucideIcon-WU3cnAkb.js";
import './Input.css';/**
 * @license lucide-react v0.367.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const f = x("CircleAlert", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
]), k = "_Input_1jjke_32", E = "_error_1jjke_60", h = "_InputWrapper_1jjke_67", v = "_ErrorIcon_1jjke_72", g = "_ErrorMessage_1jjke_83", r = {
  Input: k,
  error: E,
  InputWrapper: h,
  ErrorIcon: v,
  ErrorMessage: g
}, b = _.forwardRef(
  ({ "aria-describedby": i, "aria-invalid": t, className: d, errors: a, type: p, ...l }, I) => {
    const e = a !== void 0 && a.length > 0, n = `${y()}-error`, u = [i, e ? n : void 0].filter(Boolean).join(" ") || void 0;
    return /* @__PURE__ */ c("div", { className: r.InputWrapper, "data-cxy-name": "input", children: [
      /* @__PURE__ */ o(
        "input",
        {
          "aria-describedby": u,
          "aria-invalid": t ?? (e || void 0),
          className: j(r.Input, e ? r.error : "", d),
          ref: I,
          type: p,
          ...l
        }
      ),
      e && /* @__PURE__ */ c(m, { children: [
        /* @__PURE__ */ o(f, { "aria-hidden": !0, className: r.ErrorIcon }),
        /* @__PURE__ */ o("div", { id: n, children: a.map((s) => /* @__PURE__ */ o("p", { className: r.ErrorMessage, children: s }, s)) })
      ] })
    ] });
  }
);
b.displayName = "Input";
export {
  b as I
};
